import { TagList } from '@components/common/TagList/TagList';
import useTranslation from 'next-translate/useTranslation';
import { Container, Header } from './ArticleTags.styles';
import { ArticleTagsProps } from './ArticleTags.types';

export const ArticleTags: React.FC<ArticleTagsProps> = ({ tags }) => {
  const { t } = useTranslation('common');

  return (
    <Container>
      <Header>{t('read-more-about')}</Header>
      <TagList tags={tags} />
    </Container>
  );
};
